import Layout from '@/layout/TheLayout.vue'
import store from '@/store'
import { EXTRANET_GROUPS, SUPPLIERS_GROUPS, SUPPLIER_GROUPS_LOW_TIER, COOR_ACO_GROUP, PROVIDER_GROUP, AUX_CM_GROUP, ACO_GROUP, CODI_GROUP, GEOP_GROUP, CXP_GROUP, FACTURACION_GROUP, COBRANZA_GROUP } from './utils'

export default [
  {
    path: '/',
    name: 'Reports',
    meta: {
      title: 'Reportes',
      showInSidebar: true,
      icon: 'mdi-library',
      excludeGroup: [...EXTRANET_GROUPS, PROVIDER_GROUP]
    },
    component: Layout,
    children: [
      {
        path: '/reportes/anticipos',
        name: 'Advances Report',
        component: () => import('@/pages/Reports/Advances/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Anticipos',
          ifCan: {
            view: 'Sinister/sinister'
          }
        }
      },
      {
        path: '/reportes/aplicacion_pagos',
        name: 'Paid Applications Report',
        component: () => import('@/pages/Reports/PaidApplications/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Aplicación pagos',
          ifCan: {
            view_report: 'Sinister/historyadvances'
          }
        }
      },
      {
        path: '/corte_proveedores',
        name: 'Providers Cutoff',
        component: () => import('@/pages/Reports/ProvidersCutoff/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Corte de proveedores',
          ifCan: {
            view: 'Sinister/sinister'
          }
        }
      },
      {
        path: '/detalles_proveedor',
        name: 'Provider Details',
        component: () => import('@/pages/Reports/ProviderDetails/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Detalles de Proveedor',
          ifCan: {
            view: 'Sinister/sinister'
          }
        }
      },
      {
        path: '/reportes/datos_completos',
        name: 'Reporte de datos completos',
        component: () => import('@/pages/Reports/CompleteData/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Datos completos',
          ifCan: {
            'view_complete_data_report': 'Sinister/sinister'
          }
        }
      },
      {
        path: '/reportes/pagos_detenidos',
        name: 'Advances Stopped Report',
        component: () => import('@/pages/Reports/AdvancesStopped/index'),
        meta: {
          showInSidebar: true,
          title: 'Pagos detenidos',
          ifCan: {
            view: 'Sinister/sinister'
          }
        }
      },
      {
        path: '/reportes/facturados',
        name: 'Invoiced Report',
        component: () => import('@/pages/Reports/InvoicedReport/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Facturados',
          excludeGroup: SUPPLIERS_GROUPS.filter((g) => g !== 'GeLogistica'),
          ifCan: {
            view: 'Sinister/sinister'
          }
        }
      },
      {
        path: '/reportes/facturadosV2',
        name: 'Invoiced Report V2',
        component: () => import('@/pages/Reports/InvoicedReportV2/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Facturados V2',
          excludeGroup: SUPPLIERS_GROUPS.filter((g) => g !== 'GeLogistica'),
          ifCan: {
            view: 'Sinister/sinister'
          }
        }
      },
      {
        path: '/reportes/pagados',
        name: 'Paid Report',
        component: () => import('@/pages/Reports/PaidReport/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Pagados',
          excludeGroup: SUPPLIERS_GROUPS.filter((g) => g !== 'GeLogistica'),
          ifCan: {
            view: 'Sinister/sinister'
          }
        }
      },
      {
        path: '/reportes/ordenes_de_compra',
        name: 'Purchase Orders Report',
        component: () => import('@/pages/Reports/PurchaseOrder/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Ordenes de compra',
          ifCan: {
            view: 'Sinister/sinister'
          }
        }
      },
      {
        path: '/reportes/valuacion',
        name: 'Valuation Report',
        component: () => import('@/pages/Reports/Valuation/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Valuación',
          ifCan: {
            'view_valuation_report': 'Sinister/sinister'
          }
        }
      },
      {
        path: '/reportes/seguimiento_autorizaciones',
        name: 'Authorizations FollowUp Report',
        component: () => import('@/pages/Reports/AuthorizationsFollowUp/index'),
        props: true,
        meta: {
          showInSidebar: true,
          title: 'Seguimiento autorizaciones',
          ifCan: {
            'view_authorization_follow_up_report': 'Sinister/sinister'
          }
        }
      },
      {
        path: '/reportes/asignacion',
        name: 'AssignationReport',
        component: () => import('@/pages/Reports/AssignationReport'),
        meta: {
          title: 'Asignación',
          showInSidebar: true,
          ifCan: {
            'view_assignation_report': 'Sinister/sinister'
          }
        },
        props: (r) => ({
          hideBilling: !store.getters['account/userInGroup'](
            CODI_GROUP, GEOP_GROUP,
            'Admin',
            'KAM',
            AUX_CM_GROUP, ACO_GROUP,
            COOR_ACO_GROUP
          )
        })
      },
      {
        path: '/reportes/clara',
        name: 'ClaraReport',
        component: () => import('@/pages/Reports/Clara'),
        meta: {
          title: 'Clara',
          showInSidebar: true,
          excludeGroup: [
            'AuxCxP',
            'AuxCompras',
            'DesProveedores'],
          ifCan: {
            view: 'Quotation/quotationconceptclara'
          }
        }
      }
    ]
  },
  {
    path: '/',
    name: 'macro',
    component: Layout,
    children: [
      {
        path: '/macro',
        name: 'Macro',
        component: () => import('@/pages/MacroV2'),
        meta: {
          title: 'Macro',
          showInSidebar: true,
          icon: 'mdi-view-column',
          excludeGroup: [...EXTRANET_GROUPS, ...SUPPLIER_GROUPS_LOW_TIER, PROVIDER_GROUP]
        },
        props: (r) => ({
          codiMode:
            store.getters['account/userInGroup']('CoDi') ||
            store.getters['account/userInGroup']('Admin')
        })
      }
    ]
  },
  {
    path: '/',
    name: 'reportOne',
    component: Layout,
    meta: {
      excludeGroup: [...EXTRANET_GROUPS, PROVIDER_GROUP, FACTURACION_GROUP, COBRANZA_GROUP]
    },
    children: [
      {
        path: '/reporte-1',
        name: 'Reporte #1',
        component: () => import('@/pages/Reports/ReportOne'),
        meta: {
          title: 'Reporte #1',
          showInSidebar: true,
          icon: 'mdi-numeric-1-box'
        },
        props: (r) => ({
          hideBilling: !store.getters['account/userInGroup'](
            CODI_GROUP, GEOP_GROUP,
            'Admin',
            'KAM',
            AUX_CM_GROUP, ACO_GROUP,
            'Finanzas',
            CXP_GROUP, FACTURACION_GROUP, COBRANZA_GROUP,
            COOR_ACO_GROUP
          )
        })
      }
    ]
  }
]
